import {rowsMetPercent, toPercentScore} from './utils';
import type {ApiWorkforceProfileRecord, ApiCompetencyRow} from './workforceProfileApiTypes';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';


export const buildAlignmentScores = (raw: ApiWorkforceProfileRecord): CompanyWorkforceProfile['alignment'] => {
  const analysis = raw.targetProfileAlignmentAnalysis as ApiWorkforceProfileRecord | undefined;
  // Prefer v2/v3 section names; fall back to the legacy v1 names while the API soaks the rollout.
  const coreAlignment =
    (analysis?.coreCompetenciesAlignment as ApiWorkforceProfileRecord | undefined) ??
    (analysis?.skillsCompetenciesAlignment as ApiWorkforceProfileRecord | undefined);
  const hardAlignment =
    (analysis?.hardSkillsAlignment as ApiWorkforceProfileRecord | undefined) ??
    (analysis?.knowledgeSkillsAlignment as ApiWorkforceProfileRecord | undefined);
  const toolsAlignment = analysis?.toolsAlignment as ApiWorkforceProfileRecord | undefined;
  const domainKnowledgeAlignment = analysis?.domainKnowledgeAlignment as ApiWorkforceProfileRecord | undefined;
  const softAlignment = analysis?.softSkillsAlignment as ApiWorkforceProfileRecord | undefined;
  const responsibilitiesAlignment = analysis?.responsibilitiesAlignment as ApiWorkforceProfileRecord | undefined;

  const coreRows = coreAlignment?.rows as ApiCompetencyRow[] | undefined;
  const hardRows = hardAlignment?.rows as ApiCompetencyRow[] | undefined;
  const toolRows = toolsAlignment?.rows as ApiCompetencyRow[] | undefined;
  const domainKnowledgeRows = domainKnowledgeAlignment?.rows as ApiCompetencyRow[] | undefined;
  const softRows = softAlignment?.rows as ApiCompetencyRow[] | undefined;

  const overall =
    toPercentScore(analysis?.alignmentScore as number | undefined) ??
    toPercentScore(raw.targetProfileAlignmentScore as number | undefined);

  const coreCompetencies =
    toPercentScore(raw.skillsCompetenciesAlignmentScore as number | undefined) ?? rowsMetPercent(coreRows);
  const hardSkills =
    toPercentScore(raw.knowledgeSkillsAlignmentScore as number | undefined) ?? rowsMetPercent(hardRows);
  const tools = rowsMetPercent(toolRows);
  const domainKnowledge = rowsMetPercent(domainKnowledgeRows);
  const softSkills = rowsMetPercent(softRows);
  const responsibilities =
    toPercentScore(raw.responsibilitiesAlignmentScore as number | undefined) ??
    toPercentScore(responsibilitiesAlignment?.score as number | undefined) ??
    rowsMetPercent(responsibilitiesAlignment?.rows as ApiCompetencyRow[] | undefined);
  const culturalFitAnalysis = raw.culturalFitAnalysis as ApiWorkforceProfileRecord | undefined;
  const cultureFitSummary = culturalFitAnalysis?.cultureFit as ApiWorkforceProfileRecord | undefined;
  const culturalFit =
    toPercentScore(raw.culturalFitScore as number | undefined) ??
    toPercentScore(cultureFitSummary?.fitScore as number | undefined);

  if (
    overall == null &&
    coreCompetencies == null &&
    hardSkills == null &&
    tools == null &&
    domainKnowledge == null &&
    softSkills == null &&
    responsibilities == null &&
    culturalFit == null
  ) {
    return undefined;
  }

  return {
    overall,
    coreCompetencies,
    hardSkills,
    tools,
    domainKnowledge,
    softSkills,
    responsibilities,
    culturalFit,
  };
};
